import ViewContext from '../../context/view/Context'
import WarehouseList from './WarehouseList'
import React from 'react'

const list = <WarehouseList />
const Warehouses: React.FC = () => {
  const { layers: { warehouses, borderPoints } } = React.useContext(ViewContext)

  if (warehouses) {
    return (
      <div style={borderPoints ? { opacity: 0.5 } : undefined}>
        {list}
      </div>
    )
  }
  
  return null
}

export default Warehouses